import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { getMeetinRoomMasterList_action, insertUpdateMeetinRoomMaster_action, deleteMeetinRoomMaster_action } from '../../../../../actions/admin_module_action/master_action/manual_form_master_action/meeting_room_master_action'
import moment from "moment";
import { toastError, toastSuccess } from "../../../../../utils/constants";
import Modal from "react-modal";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import Footer from "../../../../../common_components/Footer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";



class MeetingRoomMasterList extends Component {

    // Initialize Constructor
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            // currentPage: 1,
            meetingRoomMasterList: [],
            seaterList: [],
            deleteIdObj: {},
            deleteType: '',
        }
        this.getMeetingRoomMasterList = this.getMeetingRoomMasterList.bind(this)
        this.deleteMeetingRoomMaster = this.deleteMeetingRoomMaster.bind(this)
        this.handleAdd = this.handleAdd.bind(this)
        this.onDelete = this.onDelete.bind(this)
    }

    componentDidMount() {
        this.getMeetingRoomMasterList()
    }

    getMeetingRoomMasterList(status) {
        this.setState({ isLoading: true })
        this.props.getMeetinRoomMasterList_action()
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ meetingRoomMasterList: data.data })
                    this.setState({ isLoading: false })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    deleteMeetingRoomMaster() {
        const { deleteIdObj } = this.state
        this.setState({ isLoading: true })
        console.log("deleteIdObj--->",deleteIdObj)
        this.props.deleteMeetinRoomMaster_action(deleteIdObj.ExhMeetingRoomID, deleteIdObj.SeaterMeetingRoomID, deleteIdObj.ExhMeetingRoomDateTimeSlotID, deleteIdObj.ExhmeetingRoomTimeSlotID, deleteIdObj.ExhmeetingRoomPriceHdrID)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    this.setState({ isLoading: false, deleteType: '' })
                    toastSuccess("deleted successfully")
                    setTimeout(() => {
                        this.getMeetingRoomMasterList()
                    }, 200);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
                this.setState({ isOpen: false })
            })
            .catch((err) => {
                console.log(err)
            })
    }


    // Handle Add 
    handleAdd(status) {
        this.props.navigate('/MeetingRoomMasterAU', { state: { status: status } })
    }

    onDelete(SeaterMeetingRoomID, ExhMeetingRoomID, ExhMeetingRoomDateTimeSlotID, ExhmeetingRoomTimeSlotID, ExhmeetingRoomPriceHdrID, index, status) {
        const { meetingRoomMasterList } = this.state
        console.log(status, index)
        const obj = {
            SeaterMeetingRoomID: SeaterMeetingRoomID,
            ExhMeetingRoomID: ExhMeetingRoomID,
            ExhMeetingRoomDateTimeSlotID: ExhMeetingRoomDateTimeSlotID,
            ExhmeetingRoomTimeSlotID: ExhmeetingRoomTimeSlotID,
            ExhmeetingRoomPriceHdrID: ExhmeetingRoomPriceHdrID
        }
        this.setState({ deleteIdObj: obj, deleteType: status })
        this.setState({ isOpen: true, })
    }

    render() {
        const { isLoading, isOpen, meetingRoomMasterList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />
                        <div className="main-container">
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">Meeting Room Master</h6>
                            </div>
                        </div>
                        <div className="admin-top-space p-2 px-0">
                            <div className="row m-0">
                            <div className="table-responsive">
                                <div
                                    className="card-header p-2"
                                    style={{ paddingLeft: "7px !important" }}
                                >
                                    <h3 className="card-title" style={{ fontSize: 15 }}>
                                        Meeting Room Details
                                    </h3>
                                </div>
                                <div className="table-responsive ">
                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                                        <thead>
                                            <tr>
                                                <th className="text-center" >Meeting Room Date</th>
                                                <th className="text-center" >Seater Name</th>
                                                <th className="text-center" >From Time Slot</th>
                                                <th className="text-center" >To Time Slot</th>
                                                <th className="text-center" >Time Slot Duration</th>
                                                <th className="text-center" >Price Name </th>
                                                <th className="text-center" >Price(INR)</th>
                                                <th className="text-center" >Price(USD)</th>
                                                <th style={{ width: '60px' }} className="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                meetingRoomMasterList.length > 0 ? (meetingRoomMasterList.map((data, i) => (
                                                    <tr key={i}>
                                                        <td className="text-center" >{moment(data.MeetingRoomDate).format('DD-MM-YYYY')}</td>
                                                        <td className="text-center" >{data.SeaterName}</td>
                                                        <td className="text-center" >{moment(data.FromTimeSlot).format('HH:mm')}</td>
                                                        <td className="text-center" >{moment(data.ToTimeSlot).format('HH:mm')}</td>
                                                        <td className="text-center" >{data.TimeSlotduration}</td>
                                                        <td className="text-center" >{data.PriceName}</td>
                                                        <td className="text-center" >{data.PriceINR}</td>
                                                        <td className="text-center" >{data.PriceUSD}</td>
                                                        <td className="text-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-danger btn-sm"
                                                                onClick={(e) => this.onDelete(data.SeaterMeetingRoomID, data.ExhMeetingRoomID, data.ExhMeetingRoomDateTimeSlotID, data.ExhmeetingRoomTimeSlotID, data.ExhmeetingRoomPriceHdrID, i, 1)}
                                                            >
                                                                <i className="fa fa-trash action_btn_table" />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))) : <tr><td className="text-center" colSpan={20}>No record found</td></tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="text-end mt-2">
                                <button
                                    type="button"
                                    className="btn btn-aqua"
                                    onClick={() => this.handleAdd()}
                                >
                                    Add
                                </button>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title">Do you really want to delete this record?</h5>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop"
                                        onClick={(e) => this.deleteMeetingRoomMaster()}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
                <Footer />
            </>
        )
    }
}

export default withRouter(connect(null, { getMeetinRoomMasterList_action, insertUpdateMeetinRoomMaster_action, deleteMeetinRoomMaster_action })(MeetingRoomMasterList));